var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttendance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M8 4.42969C8.3148 4.42969 8.57031 4.6852 8.57031 5V8.17188L10.4189 8.82422C10.7153 8.92923 10.8702 9.25422 10.7656 9.55078C10.6609 9.84753 10.3358 10.0039 10.0391 9.89941L7.81055 9.1123C7.56454 9.02541 7.41782 8.78715 7.43359 8.53906C7.43271 8.5261 7.42969 8.51319 7.42969 8.5V5C7.42969 4.6852 7.6852 4.42969 8 4.42969Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 2C11.3137 2 14 4.68629 14 8C14 8.55133 13.9234 9.08468 13.7842 9.5918C13.4586 9.35018 13.0838 9.17212 12.6758 9.07812C12.7554 8.73139 12.7998 8.3709 12.7998 8C12.7998 5.34903 10.651 3.2002 8 3.2002C5.34903 3.2002 3.2002 5.34903 3.2002 8C3.2002 10.651 5.34903 12.7998 8 12.7998C8.3709 12.7998 8.73139 12.7554 9.07812 12.6758C9.17212 13.0838 9.35018 13.4586 9.5918 13.7842C9.08468 13.9234 8.55133 14 8 14C4.68629 14 2 11.3137 2 8C2 4.68629 4.68629 2 8 2Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 10C13.1045 10 13.9999 10.8955 14 12C14 13.1046 13.1046 14 12 14C10.8955 14 10 13.1046 10 12C10.0001 10.8955 10.8955 10 12 10ZM12.8851 11.3525C12.8037 11.2781 12.6771 11.2836 12.6025 11.3649L11.8213 12.2168L11.3857 11.8145C11.3046 11.7397 11.1781 11.7449 11.1032 11.8258C11.0283 11.9069 11.0333 12.0335 11.1143 12.1084L11.6976 12.6468C11.7366 12.6829 11.7887 12.7021 11.8418 12.6999C11.8949 12.6976 11.9449 12.6743 11.9808 12.6351L12.8975 11.6351C12.972 11.5537 12.9665 11.4271 12.8851 11.3525Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttendance);
export default __webpack_public_path__ + "static/media/attendance.a0783eda0e831eabc5b2337d6f141726.svg";
export { ForwardRef as ReactComponent };